import { render } from "./MBadgeSummaryCard.vue?vue&type=template&id=80d8bece"
import script from "./MBadgeSummaryCard.vue?vue&type=script&lang=ts"
export * from "./MBadgeSummaryCard.vue?vue&type=script&lang=ts"
script.render = render

export default script